import React, { useState, useEffect, useRef } from 'react';
import _ from "lodash";
import Header from './Header';
import Sidebar from './Sidebar';
import CandidateTab from './CandidateTab';
import NotificationPanels from './NotificationPanels';
import '../assets/css/candidate-tab-form.css';
import MainForm from "./PV/MainForm";
import { getPv } from "../Actions/pvActions";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import GetMasterData from "../Helper/masterData";
import Footer from './Footer.js';
import StepCount from "./Common/StepCount";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import ProgressHeading from './Common/ProgressHeading.jsx';

const CandidatePv = () => {
  let { activeTab } = useParams();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [pv, setPv] = useState({});
  const [continueButton, setContinueButton] = useState({});
  const [role,setRole]=useState();

  
  const { stateOptionspv, relationOptionspv } = GetMasterData();
  const [state, setState] = useState({});
  const [unsavedEmpData, setUnsavedEmpData] = useState({});
  const form = useRef();

  

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // useEffect(() => {
  //   // let obj = {};
  //   // for (var i in stateOptions) {
  //   //   obj[stateOptions[i].value] = stateOptions[i].label;
  //   // }
  //   setState(stateOptions);
  // }, [stateOptions]);

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(getPv());
    };
    fetchData();
  }, []);

  const storeData = useSelector((state) => state.pv);
  const { pvData, loading: getLoading } = storeData;
  useEffect(() => {
    if (pvData && pvData.data && typeof pvData.data !== "undefined" && pvData.data !== null) {
      // setPv(pvData.data);

      if (Object.keys(unsavedEmpData).length == 0) {
        setPv(pvData.data);
      } else {
        const updatedData = pvData.data;
        let newData = _.cloneDeep(unsavedEmpData);
        let checksDetailsMain = _.cloneDeep(newData.checksDetails);
        let updatedChecksDetails = _.cloneDeep(updatedData.checksDetails);
        const checksDetailsMainLength = checksDetailsMain.length;
        const updatedChecksDetailsLength = updatedChecksDetails.length;
        if (checksDetailsMainLength == updatedChecksDetailsLength) {
          for (var i in checksDetailsMain) {
            checksDetailsMain[i]["uploaded_documents"] = updatedChecksDetails[i]
              .uploaded_documents
              ? updatedChecksDetails[i].uploaded_documents
              : [];
            checksDetailsMain[i]["uploaded_instant_documents"] =
              updatedChecksDetails[i].uploaded_instant_documents
                ? updatedChecksDetails[i].uploaded_instant_documents
                : [];
          }
        } else if (updatedChecksDetailsLength > checksDetailsMainLength) {
          checksDetailsMain.push(
            updatedChecksDetails[updatedChecksDetailsLength - 1]
          );
        } else {
          let checkToBeRemovedIndex = null;
          for (let i = 0; i < checksDetailsMain.length; i++) {
            let isCheckPresent = false;
            for (let j = 0; j < updatedChecksDetails.length; j++) {
              if (
                checksDetailsMain[i].case_check_id ==
                updatedChecksDetails[j].case_check_id
              ) {
                isCheckPresent = true;
                break;
              }
            }
            if (!isCheckPresent) {
              checkToBeRemovedIndex = i;
            }
          }
          if (checkToBeRemovedIndex) {
            let newChecksDetails = [];
            for (let i = 0; i < checksDetailsMain.length; i++) {
              if (i != checkToBeRemovedIndex) {
                newChecksDetails.push(checksDetailsMain[i]);
              }
            }
            checksDetailsMain = _.cloneDeep(newChecksDetails);
          }
        }

        newData.checksDetails = _.cloneDeep(checksDetailsMain);
        // setEducation(newData);
        setPv(newData);
      }


      setContinueButton(pvData.data.showContinueButton);
      
    }
  }, [pvData, storeData]);

  useEffect(() => {
    if (typeof getLoading !== "undefined" && getLoading !== null) {
      if (getLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [pvData]);

  const reRenderAgain = () => {
    dispatch(getPv());
  };


  const reRenderAgain2 = (value) => {
    setUnsavedEmpData(value);
    dispatch(getPv());
  }


  const reRenderAgainUpdate = () => {
    dispatch(getPv(1));
  };

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  return (
    <>
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}

      <section className="main-section candidate-tab-form" style={{ paddingTop: '60px' }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"PV"} />
            </div>
           
            <div className="col bg-gray-mbl">
            {/* <br/> */}
            <form className="p-3 form2 form-section" style={{ minHeight: '700px' }}>
            <div className="d-flex justify-content-between align-items-center flex-column-mbl flex-start-mbl">
                  <div>
            <StepCount activeTab={"PV"}/>
              {/* <div className="d-flex justify-content-between align-items-center">
             
                <div> */}
                  <h2 className="fnt-smi-bld">Indian Police Record Details</h2>
                  <p className="text-muted mb-0">Please add your details for verification process.</p>
                </div>
                {/* <button className="btn btn-primary">+ Add Address</button> */}
              </div>

              <hr />
              {pv.companyId === 3231 || pv.companyId == 4079 ? <>  <h6 className="fnt-smi-bld">Note : Please enter your permanent address details and add your area police station name</h6>
              <p className="text-muted">Period of stay in  address given address must be over 6 months.</p></>:<><h6 className="fnt-smi-bld">Note : Please enter details with your current address, If its alreday there, please ignore</h6>
              <p className="text-muted">Period of stay in  address given address must be over 6 months.</p></> }


              {/*Form*/}

              <MainForm
                isLoading={isLoading}
                pvData={pv}
                 continueButton={continueButton}
                // continueButton="0"
                reRenderAgain={reRenderAgain}
                reRenderAgain2={reRenderAgain2}
                reRenderAgainUpdate={reRenderAgainUpdate}
                active={activeTab}
                setIsLoading={(isLoading) => setIsLoading(isLoading)}
             //   countries={countryOptions}
                state={stateOptionspv}
                relationOption={relationOptionspv}
              />

              {/*Form*/}
              {/* <div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    <button className="btn btn-primary btn-lg mr-3">Submit for Preview</button>
                    <span className="text-muted">Please complete the all mandatory fields before final submission</span>
                  </div>
                </div>
              </div> */}
              <Footer />
              </form>
            </div>
          </div>
        </div>
      </section>

    </>
  );
}
export default CandidatePv;